    import { useState, useEffect } from 'react';

    const useScreenWidth = () => {
      const [screenWidth, setScreenWidth] = useState(window.innerWidth);

      useEffect(() => {
        const handleResize = () => {
          setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

      return screenWidth;
    };

    export default useScreenWidth;